import React, {
  Context,
  createContext,
  useContext,
  useState,
  useEffect,
  useRef,
} from 'react';
import { ILine } from '../global';
import { useLinesContext } from './Lines';

export interface EditLineContext {
  line: ILine;
  setLine: (...args) => any;
  lineSummaryRef: any;
  leftArrowRef: any;
  rightArrowRef: any;
}

export const EditLine: Context<EditLineContext> = createContext(null);

export default function EditLineContextProvider({ children }) {
  const [line, setLine] = useState(null);
  const { lines } = useLinesContext();
  const lineSummaryRef = useRef();
  const leftArrowRef = useRef();
  const rightArrowRef = useRef();

  useEffect(() => {
    let lineOnEdit = lines.find((line) => line.editActiveLine);
    if (!lineOnEdit) {
      lineOnEdit = lines.find((line) => line.edit);
    }
    lineOnEdit && setLine(lineOnEdit);
  }, [lines]);

  return (
    <EditLine.Provider
      value={{
        line,
        setLine,
        lineSummaryRef,
        leftArrowRef,
        rightArrowRef,
      }}
    >
      {children}
    </EditLine.Provider>
  );
}

export const useEditLineContext = () => useContext(EditLine);
